/**
 * SEO-заголовки H1 по адресам страниц.
 * Источник: таблица «moscowfood-h1-soglasovanie-2026-09» (колонка Артёма),
 * согласована клиентом, применена 02.09.2026.
 *
 * Зачем отдельный словарь: у категории в API нет своего поля под H1 —
 * заголовок страницы всегда равен имени категории (оно же в меню, крошках
 * и карточках товара). Здесь переопределяется ТОЛЬКО H1 страницы; имя
 * категории везде остаётся прежним. Нет ключа — показывается имя, как раньше.
 * Ключ — путь страницы без завершающего слэша.
 */
export const SEO_H1: Record<string, string> = {
  '/': 'Кейтеринг в Москве — Доставка канапе и фуршетных блюд за 2 часа',
  '/payment-sbp': 'Оплата по СБП',
  '/categories/furshetnie_nabory': 'Доставка фуршетных наборов',
  '/categories/kanape': 'Канапе для фуршета',
  '/categories/mangal': 'Шашлык на шпажках',
  '/categories/desertyi': 'Десерты для фуршета',
  '/categories/ovoschi': 'Овощи и фрукты для фуршета',
  '/categories/pitstsa': 'Пицца для мероприятий',
  '/categories/napitki': 'Напитки для мероприятий',
  '/categories/vyipechka': 'Выпечка для фуршета',
  '/categories/goryachie_zakuski': 'Горячие закуски для фуршета',
  '/categories/posuda_dlya_fursheta': 'Посуда для фуршета',
  '/categories/sendvichi_i_kruassan': 'Сэндвичи и круассаны для фуршета',
  '/categories/mini-bruskettyi': 'Брускетты для фуршета',
  '/categories/veganskoe_menyu': 'Веганское меню для фуршета',
  '/categories/salatyi': 'Салаты для фуршета',
  '/categories/tartaletki': 'Тарталетки для фуршета',
  '/categories/blinchiki': 'Блинчики для фуршета',
  '/categories/plato': 'Нарезки для фуршета',
  '/categories/mini-ruletyi': 'Рулеты для фуршета',
  '/categories/novinki': 'Новинки меню',
}

export const getSeoH1 = (path: string, fallback = ''): string =>
  SEO_H1[path] ?? fallback

/**
 * В тексте категории из админки бывает свой <h1> — на странице он оказывается
 * вторым. Понижаем до <h2>, чтобы H1 на странице был один (оформление у этих
 * тегов в тексте не задано, визуально ничего не меняется).
 */
export const demoteInnerH1 = (html: string): string =>
  html.replace(/<(\/?)h1(\s|>)/gi, '<$1h2$2')
